import { usePrimaryStore } from '@/stores/admin/primary';
import { DomRoomState as RoomState } from './api/api';
import { useServiceStore } from '@/stores/admin/service';
import { useSecondaryStore } from '@/stores/admin/secondary';
import { useLocationStore } from '@/stores/admin/location';
import { useMeetingStore } from '@/stores/meeting';
import { useAttendeeStore } from '@/stores/attendee';
import { usePhotoStore } from '@/stores/photo';

export const isEmptyObject = (obj: object): boolean => {
  return Object.keys(obj).length === 0;
};

/**
 * 会議室状態表示
 * @param state
 */
export const roomStateLabel = (state?: RoomState): string => {
  let label = '';
  switch (state) {
    case RoomState.Empty:
      label = '空室';
      break;
    case RoomState.Idle:
      label = '待機';
      break;
    case RoomState.Waiting:
      label = '待受';
      break;
    case RoomState.Preparing:
      label = '準備中';
      break;
    case RoomState.Active:
      label = '開催中';
      break;
    case RoomState.Finishing:
      label = '終了';
      break;
    default:
      break;
  }
  return label;
};

/**
 * 電計番号をxx-xxxxxx形式にする
 * @param denkei
 * @returns
 */
export const formatDenkei = (denkei: string) => {
  return denkei.slice(0, 2) + '-' + denkei.slice(2);
};

/**
 * 日時文字列を変換する（日付）
 * @param datetime
 * @returns YYYY/MM/DD (JST)
 */
export const toDateString = (datetime: string): string => {
  const date = new Date(datetime);
  return date.toLocaleDateString('ja-JP');
};

/**
 * 日時文字列のフォーマット（時間）
 * @param strDatetime
 * @returns hh:mm:ss (JST)
 */
export const toTimeString = (strDatetime: string): string => {
  const date = new Date(strDatetime);
  return date.toLocaleTimeString('ja-JP');
};

/**
 * 日時文字列のフォーマット（日時）
 * @param strDatetime
 * @returns YYYY/MM/DD hh:mm:ss (JST)
 */
export const toDatetimeString = (strDatetime: string): string => {
  const date = new Date(strDatetime);
  return date.toLocaleString('ja-JP');
};

/**
 * sleep
 * @param ms
 */
export const sleep = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

/**
 * ミーティング関連のstoreを初期化する
 */
export const clearMeetingStore = (): void => {
  useMeetingStore().clear();
  useAttendeeStore().clear();
  usePhotoStore().clear();
};

/**
 * マスタメンテナンス関連のstoreを初期化する
 */
export const clearAdminStore = (): void => {
  useServiceStore().clear();
  usePrimaryStore().clear();
  useSecondaryStore().clear();
  useLocationStore().clear();
};

/**
 * Android JavascriptInterface
 */
export interface McsWebAppInterface {
  /** 撮影画像ダウンロード */
  downloadPhoto(url: string, photoId: string): void;
}
